// extracted by mini-css-extract-plugin
module.exports = {"section":"_2987402","header":"_d076cda","gameImage":"_bf70410","title":"_13df110","titleTextSize":"_8974c90","container":"_2c18cad","buttons":"_a431b00","image":"_545c81b"};